const LOGIN_IDENTITY_TYPE_KEY = 'login_identity_type';
const LOGIN_IDENTITY_VALUE_KEY = 'login_identity_value';

export function storeAuthenticatedUser(data, context = {}) {
  localStorage.setItem('token', data.token);
  localStorage.setItem('refresh_token', data.refresh_token);
  localStorage.setItem('user_id', data.user.user_id);
  if (data.user.email) localStorage.setItem('user_email', data.user.email);
  else localStorage.removeItem('user_email');
  if (data.user.phone) localStorage.setItem('user_phone', data.user.phone);
  else localStorage.removeItem('user_phone');

  const type = context.method === 'phone' ? 'phone' : 'email';
  const value = context.identifier || data.user[type] || '';
  if (value) {
    localStorage.setItem(LOGIN_IDENTITY_TYPE_KEY, type);
    localStorage.setItem(LOGIN_IDENTITY_VALUE_KEY, value);
  } else {
    localStorage.removeItem(LOGIN_IDENTITY_TYPE_KEY);
    localStorage.removeItem(LOGIN_IDENTITY_VALUE_KEY);
  }
}

export function getLoginIdentity() {
  const type = localStorage.getItem(LOGIN_IDENTITY_TYPE_KEY);
  const value = localStorage.getItem(LOGIN_IDENTITY_VALUE_KEY);
  return type && value ? { type, value } : null;
}

export function clearAuthenticatedUser() {
  [
    'token', 'refresh_token', 'user_id', 'user_email', 'user_phone',
    LOGIN_IDENTITY_TYPE_KEY, LOGIN_IDENTITY_VALUE_KEY,
  ].forEach((key) => localStorage.removeItem(key));
}
